import { Component, Input, OnInit } from '@angular/core';
import { IboxtoolsItemUnico } from 'app/models/iboxtools-item-unico';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ConfigDataService } from '../../../../services/config-data.service';
import { Indemnizacion } from '../../../../models/indemnizacion';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { IndemnizacionService } from '../../../../services/indemnizacion.service';
import { IndemnizacionConcepto } from '../../../../models/indemnizacionConcepto';
import { IndemnizacionEditarDialogComponent } from '../indemnizacion-editar-dialog/indemnizacion-editar-dialog.component';
import { DatosOrganizativosService } from '../../../../services/datosOrganizativos.service';
import { MyValidations } from '../../../../utils/my-validations';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { PersonalService } from '../../../../services/personal.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-indemnizacion',
  templateUrl: './indemnizacion.component.html',
  styleUrls: ['./indemnizacion.component.css']
})
export class IndemnizacionComponent implements OnInit {
  mensajeExitoGuardado: string;

  constructor(private configDataSrv: ConfigDataService,
              private indemnizacionService: IndemnizacionService, 
              private fb: FormBuilder, 
              private dialog: MatDialog, 
              private snackBar: MatSnackBar, 
              private datosOrganizativosSrv: DatosOrganizativosService,
              private erroresService: ErroresService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private personalService: PersonalService,
              private momentService: MomentSetService ) { }

  @Input() legajo;
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;

  indemnizacion: Indemnizacion;
  conceptoProvi: IndemnizacionConcepto;
  conceptosList: any;
  form: FormGroup;
  indemnizacionList: any[];
  monedasList: any;
  motivosList: any;
  cortarRegistro: boolean = false;

  datosO: any;

  MensajeError: string;
  disabledEditing: boolean = true;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  submitted = false;

  indemnizacionHistoryList: any;
  toolboxEnabled: boolean = false;
  onlyNew: boolean = false;

  totalConceptos: number;
  totalImporte: number;
  monedaConcepto: string;
  
  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  indemnizacionInvalida: boolean = false;
  public cargaCompleta = false;
  MensajeRetro = "";

  get registerFormControl() { return this.form?.controls; }

  ngOnInit(): void
  {
    this.configDataSrv.getDatosIndemnizaciones()
      .subscribe(
        data => {
          this.monedasList=data["Monedas"];
          this.motivosList=data["MotivoBaja"];
        },
        error => {
          console.log(error);
        });

    this.datosOrganizativosSrv.getByPersonalId(this.personalId).subscribe(
      data => 
      { 
        data.data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        this.datosO = data.data;
      });

    this.configurarValidadores();
    this.obtenerActual();
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Indemnizacion")) this.permisoEdicion = true;
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      fecha: ['', Validators.required],
      personal: ['', Validators.required],
      motivoBaja: ['', Validators.required]
    });
  }

  cargarConceptos(idIndemnizacion)
  { 
    this.indemnizacionService.mostrarConceptos(idIndemnizacion).subscribe(
    data =>
    {
      this.conceptosList = data;
      this.calcularTotalConceptos(data);
    });      
  }

  onChangeMotivo()
  { 
  }
  
  onChangeFechas() {
    this.chequeoRetro();   
  }
  
  setearForm(indemnizacion: Indemnizacion)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(indemnizacion?.id);
      this.form.controls['personal'].setValue(indemnizacion?.personal);
      this.form.controls['fecha'].setValue(new Date(indemnizacion?.fecha));
      this.form.controls['motivoBaja'].setValue(indemnizacion?.motivoBaja);

      if (indemnizacion != null && indemnizacion.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }

      this.chequeoRetro();
      this.cargarConceptos(indemnizacion.id);
    }
  }

  calcularTotalConceptos(conceptos: IndemnizacionConcepto[])
  {
    let total = 0;
    let totalImporte = 0;
    for (let concepto of conceptos)
    {
      total += 1;
      totalImporte += concepto.importe;
    }

    this.totalConceptos = total;
    this.totalImporte = totalImporte;

    if (conceptos.length > 0)
    {
      this.monedaConcepto = conceptos[0].monedaNavigation.descripcion;
    }
    else
    {
      this.monedaConcepto = '';
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.indemnizacion))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.indemnizacionService.delete(this.indemnizacion.id).subscribe(
            response =>
            {
              this.snackBar.open("Indemnización eliminada correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              this.obtenerActual();
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.indemnizacion))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['fecha'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let indemnizacion = this.indemnizacionList.find(d => d.id == index);
    this.indemnizacion = indemnizacion;
    this.setearForm(this.indemnizacion);
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    if (this.indemnizacionList != undefined)
    {
      if (this.indemnizacion.id == 0 && this.indemnizacionList.length == 0)
      {
        this.indemnizacion = null;
        this.conceptosList = null;
      }
      else if (this.indemnizacion.id == 0 && this.indemnizacionList.length > 0)
      {
        this.indemnizacion = this.indemnizacionList[0];
      }
    }
    else
    {
      this.indemnizacion = null;
      this.conceptosList = null;
    }
    
    this.setearForm(this.indemnizacion);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    this.submitted = true;
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.form.getRawValue();

      let datosIn: Indemnizacion = {
        id: formulario.id,
        personal: formulario.personal,
        fecha: this.momentService.saveDateServer(formulario.fecha, false),
        motivoBaja: formulario.motivoBaja,
        indemnizacionConcepto: []
      };

      this.indemnizacionService.save(datosIn, [], this.cortarRegistro).subscribe(
        result =>
        {
          result.fecha = this.momentService.convertDateServer(result.fecha);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Indemnización guardada", "OK", { duration: 10000 });
          this.deshabilitarEdicion();

          this.obtenerHistorial();
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //result.fecha = result.fecha.replace('Z', '');
          this.setearForm(result);
          this.onlyNew = false;
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.indemnizacionInvalida = true;
            
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      let fecha = new Date().toString();
      let inde: Indemnizacion = { id: 0, personal: this.personalId, fecha: fecha, indemnizacionConcepto: [] };
      this.indemnizacion = inde;
      this.setearForm(inde);

      this.habilitarEdicion();
      this.form.controls['id'].setValue(0);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
    }
  }

  add()
  {    
    this.onlyNew = true;
    this.OnNewChange(true);
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarForm(false);
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarForm(true);
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.indemnizacionHistoryList = [];
    this.indemnizacionList = [];
    this.habilitarForm(false);
  }

  private obtenerHistorial()
  {
    this.indemnizacionService.getHistoryByPersonalId(this.personalId).subscribe(
      result =>
      {
        result.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.indemnizacionHistoryList = [];

        if (result.length > 0)
        {
          result.forEach(d =>
          {
            let item = new IboxtoolsItemUnico(d);
            this.indemnizacionHistoryList.push(item);
          });

          this.indemnizacionList = result;
        }
        else
        {
          this.setearForm(null);
          this.indemnizacion = null;
          this.conceptosList = null;
          this.indemnizacionList = [];
        }
      },
      error =>
      {
        console.log(error);
      });
  }

  private obtenerActual()
  {
    let fechaHoy = new Date();
    this.indemnizacionService.getByPersonalId(this.personalId).subscribe(
      datos =>
      {
        datos.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        if (datos.length > 0)
        {
          this.indemnizacion = datos.find(f=> Date.parse(f.fecha) <= fechaHoy.getTime() &&
                                              Date.parse(f.fecha) >= fechaHoy.getTime());

          if (this.indemnizacion == null) this.indemnizacion = datos[datos.length - 1];
          this.obtenerHistorial();
        }
        else
        {
          this.indemnizacion = null;
          this.conceptosList = null;
        }
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    if (this.form.get("motivoBaja").value == 0)
    {
      this.form.get("motivoBaja").setErrors({ 'invalid': true });
    }    
    
    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let fecha = this.form.get("fecha").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(fecha) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.form.get("fecha").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(fecha) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.form.get("fecha").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.form.valid)
    {
      return true;
    }
    else
    {
      this.form.markAllAsTouched();
      return false;
    }
  }

  addConcepto(e)
  {
    let mone = 1;
    if (this.datosO[0].sociedadNavigation.moneda != undefined){
      mone = this.datosO[0].sociedadNavigation.moneda 
    }
    let concepto: IndemnizacionConcepto = {
      id: 0,
      idIndemnizacion: this.indemnizacion.id,
      moneda: mone
    };

    this.abrirDialogo(concepto, 0);
  }

  abrirDialogo(concepto: IndemnizacionConcepto, index: number)
  {
    let monedas = this.monedasList.filter(f => f.id == concepto.moneda);
    let fecha = this.form.get("fecha").value;

    let dialogRef = this.dialog.open(IndemnizacionEditarDialogComponent, {
      width: '700px',
      panelClass: 'overflow',
      data: { param: concepto,
              monedasList: monedas,
              fecha: fecha},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result != '')
      {
        if (concepto.id == 0)
        {
          this.conceptosList.unshift(result);
          this.mensajeExitoGuardado = "Datos guardados";
        }
        else
        {
          this.conceptosList[index] = result;
          this.mensajeExitoGuardado = "Datos actualizados";
        }

        this.conceptosList = [...this.conceptosList];

        this.cargarConceptos(concepto.idIndemnizacion);
        this.calcularTotalConceptos(this.conceptosList);

        this.snackBar.open(this.mensajeExitoGuardado, "OK", { duration: 10000 });
      }
    });
  }

  editConcepto(row, rowIndex)
  {
    this.abrirDialogo(row, rowIndex);
  }

  deleteConcepto(row, rowIndex)
  {
    let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

    dialogRef.afterClosed().subscribe(result =>
    {
      if (result != null && result)
      {
        if (this.indemnizacion.id == 0)
        {
          this.conceptosList.splice(rowIndex, 1);

          this.cargarConceptos(row.idIndemnizacion);
          this.calcularTotalConceptos(this.conceptosList);
          return;
        }

        let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
          width: '400px'
        });
        dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

        this.eliminando = true;
        this.indemnizacionService.deleteConcepto(row.id).subscribe(
          response =>
          {
            let index = this.conceptosList.findIndex(x => x.id == row.id);
            if (index != -1)
            {
              this.conceptosList.splice(index, 1);
              this.conceptosList = [...this.conceptosList];
            }

            this.cargarConceptos(row.idIndemnizacion);
            this.calcularTotalConceptos(this.conceptosList);

            this.snackBar.open("Eliminacion de concepto correcta.", "OK", { duration: 10000 });

            this.eliminando = false;

            setTimeout(function ()
            {
              dialogProcesandoRef.close();
            });
          },
          error =>
          {
            if (error.status == 400)
            {
              this.eliminacionInvalida = true;
            }
            else
            {
              this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
            }
            this.eliminando = false;
            dialogProcesandoRef.close();
          });
      }
    });
  }

  chequeoRetro()
  {
    //Por el momento no chequea

    // this.MensajeRetro = "";
    // let fecha = this.form.get("fecha").value.toDateString();
    
    // this.personalService.ChequeoRetroactividad(this.personalId, 'Indemnizacion', fecha, fecha, true).subscribe(
    //   data =>
    //   {
    //     let resul = data;
    //     if (resul.haceRetro)
    //     {
    //       let fecha = formatDate(resul.fechaRetro, 'dd-MM-yyyy', 'en-US');
    //       this.MensajeRetro = "Esta acción generará Retro a partir del " + fecha.toString();
    //     }
    //   }
    // );
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(fecha) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(fecha) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.fecha);
      if(anterior) edita = false;  
    }
    return edita;
  }  
}
